import { datadogRum } from '@datadog/browser-rum';

interface ErrorContext {
  component?: string;
  userId?: string;
  trackId?: string;
  [key: string]: any;
}

/**
 * Log an error to Datadog RUM with consistent context structure
 *
 * @param error The error object to capture
 * @param context Additional context about the error
 */
export const logError = (error: Error | unknown, context: ErrorContext = {}) => {
  console.error('[Error]:', error);

  const errorObj = error instanceof Error ? error : new Error(String(error));

  datadogRum.addError(errorObj, {
    component: context.component,
    trackId: context.trackId,
    userId: context.userId,
    ...context,
  });
};

/**
 * Wrap an async function with error handling
 * Captures errors with Datadog RUM and continues execution
 *
 * @param fn The async function to wrap
 * @param context Context information to include with errors
 * @param fallback Optional fallback value to return on error
 */
export const withErrorHandling = async <T>(
  fn: () => Promise<T>,
  context: ErrorContext = {},
  fallback?: T
): Promise<T | undefined> => {
  try {
    return await fn();
  } catch (error) {
    logError(error, context);
    return fallback;
  }
}; 